var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiSrSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.707 5.293-5-5a1 1 0 0 0 -1.414 1.414l1.793 1.793-2.475 2.475a5 5 0 0 0 -5.487-.265l2.583 2.583a1 1 0 1 1 -1.414 1.414l-2.707-2.707-1.586 1.586 2.707 2.707a1 1 0 1 1 -1.414 1.414l-2.707-2.707-1.586 1.588 2.705 2.705a1 1 0 1 1 -1.414 1.414l-2.485-2.487a6.963 6.963 0 0 0 -.806 3.265v3.1l-2.707 2.708a1 1 0 1 0 1.414 1.414l2.707-2.707h3.1a6.954 6.954 0 0 0 4.949-2.05l5.072-5.072a4.993 4.993 0 0 0 .482-6.478l2.483-2.486 1.793 1.793a1 1 0 0 0 1.414-1.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrSyringe);
export default __webpack_public_path__ + "static/media/fi-sr-syringe.8dea17ab.svg";
export { ForwardRef as ReactComponent };